import { useForm as createUseForm } from "@ant-design-vue/use";
import { defineAsyncComponent, reactive, toRaw } from "vue";
import i18n from "../../../../i18n";
import { createLoading } from "../../../../utils/loading";
import lodash from "lodash";
import { Modal } from "ant-design-vue";
import { addModal, removeModal} from "../../../../app.logic";
import { modalStyleForm } from "../../../../utils/constant";
import { validateError } from "../../../../utils/validate";
import { base64ToFileModel } from "../../../../utils/file";

export const { isLoading, setIsLoading } = createLoading()
const ModalWebCamForm = defineAsyncComponent(() => import('./ModalWebCamForm'))

const WebCam = defineAsyncComponent(() => import('../../../../components/input/template-builder/web-cam/WebCam'))

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true }))
        .catch((error) => {
            validateError({ error })
            throw error
        });
}

export const createForm = () => {
    return {
        base64: null,
    }
}

export const createRules = () => {
    return {
        base64: [],
    }
}

export const createFormTitle = () => {
    return i18n.global.t('components.webCam.imageIdCard')
}
export const openModalWebCamForm = ({ props, onWebCam }) => {
    const refs = reactive({ form: null, isShow: true })
    const options = addModal({
        bind: lodash.merge(lodash.cloneDeep(modalStyleForm), {
            width: '600px',
            onCancel: () => {
                refs.isShow = false;
                removeModal({ options })
            },
            onOk: () => {
                refs.form.callOnClickModalOk()
                    .then((record) => {
                        Modal.confirm({
                            title: i18n.global.t('components.table.operatorAndPagination.youAreWant', { text: i18n.global.t('components.webCam.imageIdCardApprove') }),
                            onOk: () => {
                                if (onWebCam) {
                                    const fileModel = base64ToFileModel({ name: "idCard.png", base64: record?.base64 });
                                    onWebCam?.({ fileModel })
                                }
                                options.bind.onCancel()
                            }
                        });
                    })
            }
        }),
        render: () => {
            return !refs.isShow ? <span></span> :
                <ModalWebCamForm ref={(e) => { if (e) refs.form = e }} {...props}></ModalWebCamForm>
        }
    })
    return options
};

export const createField = ({ props, data }) => {
    const { viewOnly } = props
    const useForm = data.useForm
    const modelRef = useForm.modelRef
    return [
        {
            key: 'webCam',
            visible: () => true,
            colProp: () => ({ xs: 24 }),
            inputRender: () => {
                return <div class="text-center">
                    <WebCam
                        form={modelRef}
                        options={state.options}
                        viewOnly={viewOnly}
                    ></WebCam>
                </div>
            },
        },
    ]
}

export const initForm = ({ props, data, refs }) => {
    data.form = createForm();
    data.rules = createRules();
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
}

export const state = reactive({
    count: 0,
    options: {
        autoplay: true,
    },
})